import { Grid, Box, Divider } from '@material-ui/core'

import { Page, Container } from 'components'

import {
  Menu,
  OnPage,
  ButtonBaseComponent,
  CodeBox,
  Title,
  Paragraph,
  ParamsTable,
  UrlBox,
  Section,
  DetailsTable,
} from '../../components'

import { routes } from 'Routes'

const Payments = () => {
  const onPage = [
    ['#d-pagamentos', 'Pagamentos'],
    ['#d-dadostelapagamento', 'Dados de cobrança'],
    ['#d-realizarpagamento', 'Pagar cobrança'],
    ['#d-metodopagamento', 'Métodos de pagamento'],
    ['#d-informandoprodutos', 'Informando os produtos'],
    ['#d-parcelamento', 'Parcelamento de pagamentos'],
    ['#d-recuperartransacao', 'Recuperação de transação'],
    ['#d-pagarfatura', 'Pagar fatura'],
  ]
  const paymentCharge = `
{   
    "seller_auth_token": "eaab9da810313121a30ff20d1ac7e765",
    "order": {
        "code": "103",
        "customer": {
            "name": "Cliente de testes",
            "email": "cliente@testes.com",
            "document_type": "CPF",
            "document": "71475176015",
            "birth_date": "01/01/2000",
            "address": {
                "street": "Rua teste",
                "number": "777",
                "neighborhood": "Bairro teste",
                "city": "Testelândia",
                "state": "SP",
                "postal_code": "17580000"
            }
        },
        "payment": {
            "method": 6,
            "billet": {
                "description": "Descrição no boleto",
                "expiration": "11/11/2021"
            }
        },
        "products": [
            {
                "name": "Produto Teste",
                "description": "Para testes",
                "price": "70,00",
                "quantity": "2"
            },
            {
                "name": "Produto Teste 2",
                "description": "Para testes",
                "price": "30,00",
                "quantity": "3"
            }
        ]
    }
}
`
  const payInvoice = `
{   
    "seller_auth_token": "eaab9da810313121a30ff20d1ac7e765",
    "order": {
        "order_type": "invoice",
        "token": "59",
        "customer": {
            "name": "Teste jucelino",
            "email": "cliente@testes.com",
            "document_type": "CPF",
            "document": "71475176015",
            "birth_date": "01/01/2000",
            "address": {
                "street": "Rua teste",
                "number": "777",
                "neighborhood": "Bairro teste",
                "city": "Testelândia",
                "state": "SP",
                "postal_code": "17580000"
            }
        },
        "payment": {
            "method": 7
        }
    }
}
`
  const paymentHeader = [
    'Forma de pagamento',
    'ID da forma de pagamento',
    'Parâmetros obrigatórios',
  ]
  const paymentRows = [
    ['Mastercard - Cartão de crédito', '1', 'Todos os parâmetros de cartão'],
    ['Visa - Cartão de crédito', '2', 'Todos os parâmetros de cartão'],
    ['Amex - Cartão de crédito', '3', 'Todos os parâmetros de cartão'],
    ['Elo - Cartão de crédito', '4', 'Todos os parâmetros de cartão'],
    ['Hipercard - Cartão de crédito', '5', 'Todos os parâmetros de cartão'],
    ['Boleto', '6', 'Todos os parâmetros do boleto'],
    ['Pix', '7', 'Apenas o id do método'],
  ]
  return (
    <Page title="Pagamentos">
      <Container maxWidth="md">
        <Box style={{ marginBottom: '40px' }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <Menu />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Box style={{ marginBottom: '40px' }}>
                <Title variant="h5" id="d-pagamentos" subtitle="Começando">
                  Pagamentos
                </Title>
                <Paragraph>
                  Implemente pagamentos e requisições para buscar os dados de
                  cobrança, integrando essas funcionalidades ao seu carrinho de
                  compras.
                </Paragraph>
              </Box>
              <Divider />
              <Section>
                <Title variant="h6" id="d-dadostelapagamento">
                  Dados de cobrança
                </Title>
                <UrlBox
                  type="GET"
                  url="https://api.sandbox.superfin.com.br/payments/invoice/:token"
                  link="https://documenter.getpostman.com/view/11000226/TzRPhoDe#be7bb634-54c9-47ba-b36f-5045e2b0949c"
                />
                <Paragraph>
                  Este endpoint retorna os dados formatados para o seu carrinho
                  de pagamento. Para utilizá-lo, é necessário fornecer o tipo
                  (invoice ou order) e o token correspondente. Esse serviço é
                  essencial para cobrar o cliente e exibir as informações na
                  página de cobrança.
                </Paragraph>
                <ParamsTable
                  rows={[
                    [
                      'Authorization',
                      'Token de identificação referente a autenticação',
                      'String',
                      'Headers',
                      'Sim',
                    ],
                    [
                      'token',
                      'Token de identificação referente a cobrança',
                      'String',
                      'Route',
                      'Sim',
                    ],
                  ]}
                />
              </Section>
              <Divider />
              <Section>
                <Title variant="h6" id="d-realizarpagamento">
                  Pagar cobrança
                </Title>
                <UrlBox
                  type="POST"
                  url="https://api.sandbox.superfin.com.br/payments"
                  link="https://documenter.getpostman.com/view/11000226/TzRPhoDe#106292b3-4aa8-425e-b557-2724a228f312"
                />
                <Paragraph>
                  Para realizar pagamentos em nosso sistema, o usuário deve
                  fornecer os dados do cliente, os produtos sendo pagos com seus
                  respectivos valores e quantidades, e a forma de pagamento. Os
                  detalhes de todos os parâmetros aceitos pelo sistema,
                  juntamente com suas descrições, estão apresentados na tabela
                  abaixo.
                </Paragraph>
                <CodeBox
                  title="Body"
                  code={paymentCharge}
                  link="https://documenter.getpostman.com/view/11000226/TzRPhoDe#106292b3-4aa8-425e-b557-2724a228f312"
                />
                {/* <CodeBox
                  title="Body"
                  code={paymentCharge}
                  link="https://documenter.getpostman.com/view/11000226/TzRPhoDe#106292b3-4aa8-425e-b557-2724a228f312"
                /> */}
              </Section>
              <Section>
                <Title variant="h6" id="d-metodopagamento">
                  Métodos de pagamento
                </Title>
                <Paragraph>
                  Nosso sistema permite que pagamentos sejam realizados de
                  diversas formas, é importante ressaltar que ao escolher uma
                  forma especifica, é obrigatório mandar os dados de pagamento
                  da mesma, por exemplo, ao escolher cartão é obrigatório mandar
                  os dados do cartão de crédito, a tabela abaixo especifica as
                  formas de pagamentos aceitas em nosso sistema.
                </Paragraph>
                <DetailsTable header={paymentHeader} rows={paymentRows} />
              </Section>
              <Section>
                <Title variant="h6" id="d-informandoprodutos">
                  Informando os produtos{' '}
                </Title>
                <Paragraph>
                  É possível enviar 1 ou mais produtos para o pagamento, é
                  importante ressaltar que mesmo que apenas 1 produto seja
                  enviado nós recebemos um array de produtos, ou seja será
                  necessário enviar um array com um único item.
                </Paragraph>
              </Section>
              <Section>
                <Title variant="h6" id="d-parcelamento">
                  Parcelamento de pagamentos
                </Title>
                <Paragraph>
                  Pagamentos com cartão de crédito permitem o parcelamento do
                  valor, para parcelar o pagamento basta enviar o parâmetro
                  order[payment][split_number] com o número de parcelas que você
                  deseja, caso este parâmetro não seja enviado o sistema
                  entenderá que o pagamento será feita em uma única parcela.
                </Paragraph>
              </Section>
              <Section>
                <Title variant="h6" id="d-recuperartransacao">
                  Recuperação de transação
                </Title>
                <Paragraph>
                  Caso seja enviado o code de uma transação já existente o
                  sistema irá tentar recuperar esta transação, caso os
                  parâmetros de cliente e produto sejam enviados diferentes um
                  erro será retornado, caso recuperado outro pagamento será
                  criado para a transação pré existente, a menos que está
                  transação esteja Paga, Cancelada ou Aguardando confirmação.{' '}
                </Paragraph>
              </Section>
              <Section></Section>
              <Section>
                <ParamsTable
                  rows={[
                    [
                      'seller_auth_token',
                      'Token do vendedor',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[code]',
                      'Identificador externo do pedido',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer]',
                      'Cliente que está realizando o pagamento',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][name]',
                      'Nome do cliente que está realizando o pagamento',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][email]',
                      'E-mail do cliente que está realizando o pagamento',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][document]',
                      'Documento do cliente que está realizando o pagamento(Sem pontuação)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][document_type]',
                      'Tipo de documento do cliente que está realizando o pagamento(CPF ou CNPJ)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][birth_date]',
                      'Data de nascimento do cliente que está realizando o pagamento (ex: 01/01/2000)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][one_id_token]',
                      'Token do cliente no OneId',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address]',
                      'Endereço do cliente',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][street]',
                      'Rua onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][number]',
                      'Número da residência onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][neighborhood]',
                      'Bairro onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][city]',
                      'Cidade onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][state]',
                      'Estado onde o cliente reside (ex: SP)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][postal_code]',
                      'CEP do cliente ex(17580000)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment]',
                      'Dados sobre o pagamento do pedido',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][method]',
                      'ID do método de pagamento**(Tabela abaixo)**',
                      'integer',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][split_number]',
                      'Número de parcelas(Somente para cartão de cŕedito)',
                      'integer',
                      'Body',
                      'Não',
                    ],
                    [
                      'order[payment][card]',
                      'Dados do cartão de crédito utilizado no pagamento',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][name]',
                      'Nome impresso no cartão',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][number]',
                      'Número do cartão',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][cvv]',
                      'Código de segurança',
                      'integer',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][expiration]',
                      'Vencimento do cartão (ex: 12/22)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][billet]',
                      'Dados do boleto utilizado no pagamento',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][billet][description]',
                      'Texto impresso no corpo do boleto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][billet][expiration]',
                      'Data de vencimento do boleto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products]',
                      'Produtos a serem pagos',
                      'array',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][name]',
                      'Nome do produto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][description]',
                      'Descrição do produto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][price]',
                      'Preço unitário do produto',
                      'float',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][quantity]',
                      'Quantidade do produto',
                      'integer',
                      'Body',
                      'Sim',
                    ],
                  ]}
                />
              </Section>
              <Divider />
              <Section>
                <Title variant="h6" id="d-pagarfatura">
                  Pagar Fatura
                </Title>
                <UrlBox
                  type="POST"
                  url="https://api.sandbox.superfin.com.br/payments/pay"
                  link="https://documenter.getpostman.com/view/11000226/TzRPhoDe#06c7099f-732d-4f1b-be07-e8d245240e31"
                />
                <Paragraph>
                  Para realizar pagamentos de fatura em nosso sistema o usuário
                  deverá informar dados do cliente que está realizando
                  pagamento, o tipo da transação(invoice) o token(id da fatura),
                  e também a forma com que este pagamento é feito. Os detalhes
                  de todos os parâmetros que o sistema aceita, tal como suas
                  respectivas descrições estão presentes na tabela abaixo.
                </Paragraph>
                <CodeBox
                  title="Body"
                  code={payInvoice}
                  link="https://documenter.getpostman.com/view/11000226/TzRPhoDe#106292b3-4aa8-425e-b557-2724a228f312"
                />
                <ParamsTable
                  rows={[
                    [
                      'seller_auth_token',
                      'Token do vendedor',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[code]',
                      'Identificador externo do pedido',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer]',
                      'Cliente que está realizando o pagamento',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][name]',
                      'Nome do cliente que está realizando o pagamento',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][email]',
                      'E-mail do cliente que está realizando o pagamento',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][document]',
                      'Documento do cliente que está realizando o pagamento(Sem pontuação)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][document_type]',
                      'Tipo de documento do cliente que está realizando o pagamento(CPF ou CNPJ)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][birth_date]',
                      'Data de nascimento do cliente que está realizando o pagamento (ex: 01/01/2000)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][one_id_token]',
                      'Token do cliente no OneId',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address]',
                      'Endereço do cliente',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][street]',
                      'Rua onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][number]',
                      'Número da residência onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][neighborhood]',
                      'Bairro onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][city]',
                      'Cidade onde o cliente reside',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][state]',
                      'Estado onde o cliente reside (ex: SP)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[customer][address][postal_code]',
                      'CEP do cliente ex(17580000)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment]',
                      'Dados sobre o pagamento do pedido',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][method]',
                      'ID do método de pagamento**(Tabela abaixo)**',
                      'integer',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][split_number]',
                      'Número de parcelas(Somente para cartão de cŕedito)',
                      'integer',
                      'Body',
                      'Não',
                    ],
                    [
                      'order[payment][card]',
                      'Dados do cartão de crédito utilizado no pagamento',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][name]',
                      'Nome impresso no cartão',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][number]',
                      'Número do cartão',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][cvv]',
                      'Código de segurança',
                      'integer',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][card][expiration]',
                      'Vencimento do cartão (ex: 12/22)',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][billet]',
                      'Dados do boleto utilizado no pagamento',
                      'object',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][billet][description]',
                      'Texto impresso no corpo do boleto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[payment][billet][expiration]',
                      'Data de vencimento do boleto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products]',
                      'Produtos a serem pagos',
                      'array',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][name]',
                      'Nome do produto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][description]',
                      'Descrição do produto',
                      'string',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][price]',
                      'Preço unitário do produto',
                      'float',
                      'Body',
                      'Sim',
                    ],
                    [
                      'order[products][quantity]',
                      'Quantidade do produto',
                      'integer',
                      'Body',
                      'Sim',
                    ],
                  ]}
                />
              </Section>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ButtonBaseComponent
                    nextName="Minhas informações"
                    previousName="Cobrança avulsa"
                    previousRoute={routes.documentation.oneTimeCharge}
                    nextRoute={routes.documentation.myInformation}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <OnPage page={onPage} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default Payments
